import { createAction, props } from '@ngrx/store';
import { IBenchmark } from '../models/benckmark.model';

export const loadGetBenchmarks = createAction('[GetBenchmark] Load GetBenchmarks');

export const loadGetBenchmarksSuccess = createAction('[GetBenchmark] Load GetBenchmarks Success', props<{ response: IBenchmark[] }>());

export const loadGetBenchmarksFailure = createAction('[GetBenchmark] Load GetBenchmarks Failure', props<{ error: Error | any }>());
